import {
	CreateVestingTermLeaverProvisionDto,
	UpdateVestingTermLeaverProvisionDto,
	VestingTermLeaverProvisionRes,
} from '@dealstack/shared/lib/generated';

import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { LeaverProvision } from './LeaverProvision/LeaverProvision';
import { Button } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

interface Props {
	vestingTermId: string;
	leaverProvisions: VestingTermLeaverProvisionRes[];
	leaverProvisionCreatorOpen: boolean;
	setLeaverProvisionCreatorOpen: (bool: boolean) => void;
	onCreateVestingTermLeaverProvision: (
		vestingTermLeaverProvision: CreateVestingTermLeaverProvisionDto
	) => void;
	onUpdateVestingTermLeaverProvision: (
		leaverProvisionId: string,
		formValues: UpdateVestingTermLeaverProvisionDto
	) => void;
	onDeleteVestingTermLeaverProvision: (leaverProvisionId: string) => void;
}

export const LeaverProvisions = ({
	vestingTermId,
	leaverProvisions,
	leaverProvisionCreatorOpen,
	setLeaverProvisionCreatorOpen,
	onCreateVestingTermLeaverProvision,
	onUpdateVestingTermLeaverProvision,
	onDeleteVestingTermLeaverProvision,
}: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<div className="mt-2">
			{leaverProvisions.map((leaverProvision) => (
				<div key={leaverProvision.id} className="mb-2">
					<LeaverProvision
						vestingTermId={vestingTermId}
						leaverProvision={leaverProvision}
						setLeaverProvisionCreatorOpen={setLeaverProvisionCreatorOpen}
						onCreateVestingTermLeaverProvision={onCreateVestingTermLeaverProvision}
						onUpdateVestingTermLeaverProvision={onUpdateVestingTermLeaverProvision}
						onDeleteVestingTermLeaverProvision={onDeleteVestingTermLeaverProvision}
					/>
				</div>
			))}
			{leaverProvisionCreatorOpen ? (
				<div key="leaver_provision_creator" className="mb-2">
					<LeaverProvision
						vestingTermId={vestingTermId}
						leaverProvisionCreatorOpen={leaverProvisionCreatorOpen}
						setLeaverProvisionCreatorOpen={setLeaverProvisionCreatorOpen}
						onCreateVestingTermLeaverProvision={onCreateVestingTermLeaverProvision}
						onUpdateVestingTermLeaverProvision={onUpdateVestingTermLeaverProvision}
						onDeleteVestingTermLeaverProvision={onDeleteVestingTermLeaverProvision}
					/>
				</div>
			) : (
				<Button
					onClick={() => setLeaverProvisionCreatorOpen(true)}
					variant="ghost"
					leftSection={<Icon variant="plus" size="lg" />}
				>
					{tCommonUi('vesting_terms.add_leaver_provision')}
				</Button>
			)}
		</div>
	);
};
